import * as a9 from '../../analytics'
import configuration from '../../configuration'
import type { NavigationItemWithArticles } from '../../types/domain'

const { PAYPER_MAGIC_BROWSE_ROUTE } = configuration as Record<string, string>

interface ClickArticleParams extends a9.BaseParams {
  name: NavigationItemWithArticles
  destinationArticleId?: string
  destinationMediaId?: string
}

export const openArticle = (
  articleUrl: string,
  evParams: ClickArticleParams,
) => {
  a9.dispatchEvent(a9.Event.CLICK_ARTICLE, evParams)

  window.location.href = `${PAYPER_MAGIC_BROWSE_ROUTE}?url=${articleUrl}`
}
